export default function New() {
  return (
    <div>
      Claims coming soon
    </div>
  )
}
